import { Component, h } from '@stencil/core';

@Component({
  tag: 'signet-h4',
  styleUrl: 'signet-h4.scss',
  shadow: true,
})
export class SignetH4 {
  render() {
    return <h4><slot /></h4>;
  }
}
